import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

export const useSelectedComparisonsData = () => {
  const savedComparisons = useSelector((state) => state.compareData?.savedComparisons);
  const [searchParams] = useSearchParams();
  const uuid = Number(searchParams.get('uuid'));

  const selectedData = useMemo(() => {
    if (!Array.isArray(savedComparisons)) return null;
    return savedComparisons?.find((item) => item?.id === uuid);
  }, [uuid, savedComparisons]);

  return { selectedData, savedComparisons };
};
